import { render } from "./PageLayoutPDF.vue?vue&type=template&id=7c20b2be&scoped=true"
const script = {}

import "./PageLayoutPDF.vue?vue&type=style&index=0&id=7c20b2be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c20b2be"]])

export default __exports__